import * as React from 'react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { TableRow, TableCell } from '@/components/ui/table';
import type { OffcutItemDto } from '@cutlyft/zod-schemas';
import { TransitionModal } from './transition-modal';

interface OffcutRowProps {
  offcut: OffcutItemDto;
}

const STATUS_VARIANT: Record<
  OffcutItemDto['inventoryStatus'],
  'default' | 'secondary' | 'destructive' | 'outline'
> = {
  AVAILABLE: 'default',
  CONSUMED: 'secondary',
  SCRAPPED: 'destructive',
};

export function OffcutRow({ offcut }: OffcutRowProps) {
  const [modalOpen, setModalOpen] = React.useState(false);

  return (
    <>
      <TableRow>
        <TableCell className="font-mono text-xs">{offcut.id}</TableCell>
        <TableCell className="font-mono">{offcut.lengthMm} mm</TableCell>
        <TableCell>
          <Badge variant={STATUS_VARIANT[offcut.inventoryStatus]}>
            {offcut.inventoryStatus.charAt(0) + offcut.inventoryStatus.slice(1).toLowerCase()}
          </Badge>
        </TableCell>
        <TableCell className="text-fg-muted text-xs">
          {offcut.storageLocation ?? '—'}
        </TableCell>
        <TableCell className="text-fg-muted text-xs">
          {offcut.sourceRunId ? `Run #${offcut.sourceRunId}` : '—'}
        </TableCell>
        <TableCell className="text-right">
          {offcut.inventoryStatus === 'AVAILABLE' && (
            <Button variant="outline" size="sm" onClick={() => setModalOpen(true)}>
              Transition
            </Button>
          )}
        </TableCell>
      </TableRow>
      {modalOpen && (
        <TransitionModal offcut={offcut} open={modalOpen} onOpenChange={setModalOpen} />
      )}
    </>
  );
}
